import { type Asset } from "@overmap-ai/common"
import { selectAssetById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { AssetTypeIcon } from "../../../../components/Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../../../../components/IndexLabels/AssetIndexLabel"
import { useAppSelector } from "../../../../store"

export const AssetMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: Asset["uuid"] }

	const asset = useAppSelector(selectAssetById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) overflow-hidden whitespace-nowrap rounded-md px-1"
			as="span"
		>
			{!!asset && (
				<Link
					className="whitespace-nowrap"
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/assets/$assetId"
					params={(prev) => ({ ...prev, assetId: asset.uuid })}
				>
					<AssetTypeIcon assetTypeId={asset.asset_type} background={false} className="align-sub" />
					<AssetIndexLabel assetId={asset.uuid} />
				</Link>
			)}
		</NodeViewWrapper>
	)
})
AssetMentionComponent.displayName = "AssetMentionComponent"
